module.exports = __webpack_public_path__ + "static/media/53.49bf03fe.png";